import { FeatureType, Menu, MenuType } from './menu-item-shared';

const adminUsers: Menu = {
  state: 'users',
  name: 'menu.rocketmaster.users',
  type: MenuType.Static,
  icon: 'person',
};

const adminLicenses: Menu = {
  state: 'licenses',
  name: 'globals.licenses',
  type: MenuType.Static,
  icon: 'verified',
};

const adminStationsMenu: Menu = {
  state: 'stations',
  name: 'menu.rocketmaster.stations',
  type: MenuType.Static,
  icon: 'ev_station',
};

const adminChargingMenu: Menu = {
  state: 'charging',
  name: 'menu.rocketmaster.charging',
  type: MenuType.Static,
  icon: 'ev_station',
};

const adminPermissionsMenu: Menu = {
  state: 'permissions',
  name: 'menu.rocketmaster.permissions',
  type: MenuType.Static,
  icon: 'lock',
};

const adminUserGroupsMenu: Menu = {
  state: 'user-groups',
  name: 'menu.rocketmaster.user-groups',
  type: MenuType.Static,
  icon: 'group',
};

const adminStationGroupsMenu: Menu = {
  state: 'station-groups',
  name: 'menu.rocketmaster.station-groups',
  type: MenuType.Static,
  icon: 'group',
};

const adminHubjecActionsMenu: Menu = {
  state: 'hubject-actions',
  name: 'menu.rocketmaster.hubject-actions',
  type: MenuType.Static,
  icon: 'insert_drive_file',
};

const adminHubjectChargingMenu: Menu = {
  state: 'hubject-charging-reports',
  name: 'menu.rocketmaster.hubject-charging-reports',
  type: MenuType.Static,
  icon: 'insert_drive_file',
};

const adminOcpiPartnersMenu: Menu = {
  state: 'ocpi-partners',
  name: 'OCPI Partners',
  type: MenuType.Static,
  icon: 'lan',
};

const adminRfidMenu: Menu = {
  state: 'rfid',
  name: 'menu.rocketmaster.rfid',
  type: MenuType.Static,
  icon: 'nfc',
};

const adminCardTerminalsMenu: Menu = {
  state: 'card-terminals',
  name: 'menu.rocketmaster.card-terminals',
  type: MenuType.Static,
  icon: 'point_of_sale',
};

const adminPriceRuleMenu: Menu = {
  state: 'price-rules',
  name: 'menu.rocketmaster.price-rules',
  type: MenuType.Static,
  icon: 'lock',
};

const adminPricePlansMenu: Menu = {
  state: 'price-plans',
  name: 'menu.rocketmaster.price-plans',
  type: MenuType.Static,
  icon: 'payments',
};

const adminCustomStationCodes: Menu = {
  state: 'custom-station-codes',
  name: 'menu.rocketmaster.custom-station-codes',
  type: MenuType.Static,
  icon: 'qr_code',
};
const adminCarIdsMenu: Menu = {
  state: 'car',
  name: 'menu.rocketmaster.car-ids',
  type: MenuType.Static,
  icon: 'directions_car',
};
const adminBlockedDriversMenu: Menu = {
  state: 'blocked-drivers',
  name: 'menu.rocketmaster.blocked-drivers',
  type: MenuType.Static,
  icon: 'money_off',
};

export const adminMenu: Menu = {
  state: 'rocketmaster',
  name: 'menu.rocketmaster',
  type: MenuType.Expandable,
  icon: 'rocket',
  requiredFeatures: [FeatureType.Admin],
  children: [
    adminUsers,
    adminLicenses,
    adminStationsMenu,
    adminChargingMenu,
    adminPermissionsMenu,
    adminUserGroupsMenu,
    adminStationGroupsMenu,
    adminHubjecActionsMenu,
    adminHubjectChargingMenu,
    adminOcpiPartnersMenu,
    adminRfidMenu,
    adminCardTerminalsMenu,
    adminPriceRuleMenu,
    adminPricePlansMenu,
    adminCustomStationCodes,
    adminCarIdsMenu,
    adminBlockedDriversMenu,
  ],
};
